export default __webpack_public_path__ + "static/media/logoMICROSOFT_lastone.c8fd9682.png";